// Service for fetching user profile data from backend
import { getApiUrl } from './apiConfig';
import { supabase } from './supabase';

export const fetchUserProfile = async () => {
  try {
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError || !session?.user?.id) {
      console.error('No user session found:', sessionError);
      return null;
    }
    
    const userId = session.user.id;
    console.log('🔍 Fetching profile for user ID:', userId);
    
    // Fetch profile data from Go backend
    const response = await fetch(getApiUrl(`student-profile?user_id=${userId}`), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (!response.ok) {
      console.error('Failed to fetch profile:', response.status, response.statusText);
      return null;
    }
    
    const profileData = await response.json();
    console.log('📊 Profile data fetched:', profileData);
    
    // Transform the data to match what the frontend expects
    return {
      username: profileData.username || '',
      displayUsername: profileData.displayUsername || '',
      name: profileData.name || '',
      grade: profileData.grade || '',
      schoolName: profileData.school_name || profileData.schoolName || '',
      favoriteAnimal: profileData.favorite_animal || profileData.favoriteAnimal || '',
      favoriteSnack: profileData.favorite_snack || profileData.favoriteSnack || '',
      favoriteRelax: profileData.relaxation_method || profileData.relaxationMethod || profileData.favorite_relax || profileData.favoriteRelax || '',
      userId: userId
    };
    
  } catch (error) {
    console.error('Error fetching user profile:', error);
    return null;
  }
};

export const saveProfileToLocalStorage = (profileData) => {
  try {
    // Save as structured data
    localStorage.setItem('studentProfileData', JSON.stringify(profileData));
    
    // Also save individual items for backward compatibility
    localStorage.setItem('signupUsername', profileData.username);
    localStorage.setItem('signupName', profileData.name);
    localStorage.setItem('currentGrade', profileData.grade);
    localStorage.setItem('schoolName', profileData.schoolName);
    localStorage.setItem('favoriteAnimal', profileData.favoriteAnimal);
    localStorage.setItem('favoriteSnack', profileData.favoriteSnack);
    localStorage.setItem('favoriteRelax', profileData.favoriteRelax);
    
    // Dispatch custom event to notify components that profile was updated
    window.dispatchEvent(new CustomEvent('profileUpdated'));
    
    console.log('💾 Profile data saved to localStorage and event dispatched');
  } catch (error) {
    console.error('Error saving profile to localStorage:', error);
  }
};
